<template>
    <div class="container">
        <h2 class="title is-5">ウォッチャーを使った画面遷移検出のサンプルコード</h2>
        <p>ウォッチャー(watch)を使った画面遷移検出のサンプルコードです</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <RouterWatchComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/5413bc6e2be0b6963695ab4ec75b1851" data-iframely-url="//cdn.iframe.ly/nHmyY84"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>ウォッチャーを使った画面遷移検出のサンプルコードです。</p>
        <p>例えば、パラメーターを変えた時に、this,$router.push()ではrouterが働かずにデータの更新がされません。そんな時にはwatchでパラメータを監視すればアクションを指定することができます。</p>
    </div>
</template>

<script>
import RouterWatchComponent from  '@/components/RouterWatchComponent.vue'
export default {
    components:{
        RouterWatchComponent
    },
    mounted(){
        const title = "ウォッチャーを使った画面遷移検出のサンプルコード｜あめねこサンプルコード集"
        const description = "Vue.jsで作るウォッチャーを使った画面遷移検出のサンプルコードです"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "ウォッチャーを使った画面遷移検出のサンプルコード" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/router-watch";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
    padding: 10px;
}

</style>